import {
	PaginationOrderHow,
	useTermItemsQuery,
} from '../../../graphql/graphql';

export default function useInsuranceCompanies() {
	const { data, isLoading } = useTermItemsQuery({
		termType: 'insurance_companies',
		pagination: {
			take: 999,
			order: { key: 'value', how: PaginationOrderHow.Asc },
		},
	});

	return { data, isLoading };
}
